import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

/**
 * Alias de l'écran de réinitialisation du mot de passe.
 *
 * L'e-mail « mot de passe oublié » envoyé par l'API (`MailService.sendPasswordReset`)
 * pointe vers `/reset?token=…` alors que l'écran vit sous `/reset-password`
 * (défaut DEF-002 de la recette MVP). Cette route redirige vers l'écran réel
 * en conservant le jeton.
 */
export const Route = createFileRoute('/reset')({
  validateSearch: z.object({ token: z.string().optional() }),
  beforeLoad: ({ search }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router utilise une exception de redirection
    throw redirect({ to: '/reset-password', search: { token: search.token }, replace: true });
  },
});
